import { makeStyles } from "@material-ui/core/styles";

export const materialComponentStyles = makeStyles((theme) => ({
    checkBoxLabel : {
        paddingTop: "7px",
    },
}));
